
class cardVariantSelects extends HTMLElement {
    constructor() {
        super();

        const cardItem = this.closest('[js-card-item]');
        this.variantId = cardItem.querySelector('[js-cart-variant-value]');
        this.atcButton = cardItem.querySelector('[js-card-atc-btn]');
        this.variantData = this.getVariantData();
        this.addEventListener('change', this.onVariantChange.bind(this)); 
    }

    onVariantChange() {
        const selectedOptions = this.updateOptions(); 
        const selectedVariant = this.currentVariant(selectedOptions); 

        if (selectedVariant) {
            this.variantId.value = selectedVariant.id;
        }
        this.updateAddToCart(selectedVariant);
    }

    getVariantData() {
        return JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }

    updateOptions() {
        return [...this.querySelectorAll('select')].map((select) => select.value);
    }

    currentVariant(selectedOptions) {
        return this.variantData.find((variant) => {
            return variant.options.every((option, index) => option === selectedOptions[index]);
        });
    }

    updateAddToCart(selectedVariant) {
        if (selectedVariant.available) {
            this.atcButton.classList.remove('is-sold-out'); 
        } else {
            this.atcButton.classList.add('is-sold-out'); 
        }
    }
}

customElements.define('card-variant-selects', cardVariantSelects);